import { Accordion, AccordionDetails, AccordionSummary, Alert, Autocomplete, Box, Button, Stack, Table, TableCell, TableRow, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useValue } from '../../../context/ContextProvider';
import ScutInfo from '../ScutInfo';


const PosAdd = ({ currentUser, dispatch, productosOptions, addGeneral, addPan, codigoBarrasRef, showAlerta, alerta, setOpenScutDialog }) => {
    const { state: { productos } } = useValue();
    const [nombreProductoState, setNombreProductoState] = useState(null);
    const [codigoBarrasState, setCodigoBarrasState] = useState('');
    //const [openScutDialog, setOpenScutDialog] = useState(false);



    //===============================================================================================================
    // Funcion para añadir o actualizar la lista de productos seleccionados
    //===============================================================================================================
    const addProduct = (nombreProducto, n) => {
        //console.log('addProduct: ', {nombreProducto, n});
        const productoEncontrado = productos.find((producto) => producto.product == nombreProducto);
        if (productoEncontrado?.type == 'Pan') {
            //La gestion del pan es diferente al resto de los productos
            setNombreProductoState(productoEncontrado.product);
            addPan(productoEncontrado, n);
            setCodigoBarrasState("");
            setNombreProductoState("");
            codigoBarrasRef.current.select();
        } else {
            //El producto es general, no es pan
            if (productoEncontrado) {
                //console.log({productoEncontrado});
                setNombreProductoState(productoEncontrado.product);
                addGeneral(productoEncontrado, n);
                setCodigoBarrasState("");
                setNombreProductoState("");
                codigoBarrasRef.current.select();
            } else {
                setCodigoBarrasState("");
                setNombreProductoState("");
            }
        }
    }
    //===============================================================================================================


    //===============================================================================================================
    // Funcion para añadir o actualizar los productos si la ventana codigoBarras pierde el enfoque.  Por el momento
    // sólo busca codigos de barras completos, no shortcuts.
    //===============================================================================================================
    const handleCodigoBarrasBlur = (event) => {
        if (codigoBarrasState != "") {
            if (codigoBarrasState.length <= 6) {
                //Se trata de un shorcut
            } else {
                //Buscar con código de barras
                const productoEncontrado = productos.find((producto) => producto.codBar == codigoBarrasState);
                if (productoEncontrado) {
                    setNombreProductoState(productoEncontrado.product);
                } else {
                    setCodigoBarrasState("");
                    setNombreProductoState("");
                }
            }
        }
    }
    //===============================================================================================================


    //===============================================================================================================
    // Funcion para añadir o actualizar los productos cuando se presiona enter en la casilla de codigoBarras.  
    // Busca codigos de barras completos y shortcuts.  Shortcuts si la cantidad de caracteres es 8 o menos.
    // El formato del shortcut es:
    //      - Código shortcut de 1 a 3 caracteres
    //      - Número que representa la cantidad de productos a añadir a la lista.
    // Ambos strings pueden estar juntos o separados por un espacio.  Ej. 'p3' o 'p 3' significa: pan surtido 3 unidades
    //===============================================================================================================
    const handleCodigoBarrasEnter = () => {
        if (codigoBarrasState != "") {
            if (codigoBarrasState.length <= 6) {
                //Se trata de un shorcut
                const pos = codigoBarrasState.search(/\d/); //Busca la posición del primer caracter numérico
                //console.log({ pos });
                let n = 1;      //Es la cantidad de productos a añadir a la lista.  Por defecto 1.
                if (pos < 0) {
                    //n = 1;      //no hay número en el string, por lo tanto se confirma cantidad = 1
                    var scut = codigoBarrasState;
                } else {
                    n = parseInt(codigoBarrasState.slice(pos));
                    scut = codigoBarrasState.slice(0, pos).trim();
                    //console.log({ n, scut });
                }

                const productoEncontrado = productos.find((producto) => producto.scut == scut);
                if (productoEncontrado != undefined) {
                    //console.log({ n });
                    addProduct(productoEncontrado.product, n);
                } else {
                    setCodigoBarrasState('');
                    showAlerta("Shorcut desconocido.");
                }
            } else {
                //Buscar con código de barras
                const productoEncontrado = productos.find((producto) => producto.codBar == codigoBarrasState);
                if (productoEncontrado != undefined) {
                    addProduct(productoEncontrado.product, 1);
                } else {
                    setCodigoBarrasState('');
                    showAlerta("El producto no existe.");
                }
            }

        }
    }
    //===============================================================================================================


    //===============================================================================================================
    // Funcion que gestiona el ingreso de productos mediante la casilla de selección multiple.  Mientras no se de
    // la razon 'selectOption', que es cuando el usuario selecciona explicitamente una opción, lo único que hace es
    // actualiza la variable que se muestra en la ventana.
    //===============================================================================================================
    const handleProductoChange = (event, value, reason) => {
        //console.log({ event, value, reason });
        setNombreProductoState(event.currentTarget.textContent);
        if (reason == 'selectOption') {
            //console.log('Opcion seleccionada');
            const productoEncontrado = productos.find((producto) => producto.id == value.id);
            //console.log({ productoEncontrado });
            if (productoEncontrado) {
                setCodigoBarrasState(productoEncontrado.codBar);
                setNombreProductoState(productoEncontrado.product);
                //console.log('Añadiendo producto...');
                addProduct(productoEncontrado.product, 1);
            } else {
                //setCodigoBarrasState("");
                setNombreProductoState("");
            }
        }
    }
    //===============================================================================================================

    const handleClickOpen = () => {
        setOpenScutDialog(true);
    };

    //===============================================================================================================
    // Renderización de página o bloque
    //===============================================================================================================
    return (
        <Box>
            <Stack direction='column'>
                <Box sx={{ height: '40%' }} borderBottom={1}>
                    <form
                    //</Box>onSubmit={(event) => handleSubmitIngresar(event)}
                    >
                        <Box paddingBottom={2}>
                            <TextField
                                autoFocus={true}
                                autoComplete='off'      //Para que no salga opciones de texto anteriores
                                margin='normal'
                                variant='outlined'
                                id='codigoBarras'
                                label='Código de Barras'
                                type='text'
                                fullWidth
                                inputRef={codigoBarrasRef}
                                value={codigoBarrasState}
                                onBlur={(event) => handleCodigoBarrasBlur(event)}   //Función cuando pierde el focus
                                onChange={(event) => setCodigoBarrasState(event.target.value)}
                                onFocus={event => event.target.select()}
                                inputProps={{
                                    onKeyPress: event => {          //Para gestionar enter
                                        const { key } = event;
                                        if (key === "Enter") {
                                            handleCodigoBarrasEnter();
                                        }
                                    },
                                    minLength: 8
                                }}
                            />
                        </Box>

                        <Box paddingBottom={3}>
                            <Autocomplete
                                disablePortal={false}
                                id="combo-box-demo"
                                options={productosOptions}
                                fullWidth
                                renderInput={(params) => <TextField {...params} label="Producto" />}
                                ListboxProps={{ style: { maxHeight: 150 } }}
                                value={nombreProductoState}
                                onChange={(event, value, reason) => handleProductoChange(event, value, reason)}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                required
                            />
                        </Box>
                    </form>
                    {(alerta?.length > 0) &&
                        <Alert severity="warning" onClose={() => { }}>
                            {alerta}
                        </Alert>
                    }
                </Box>
                <Box pt={2} sx={{display: 'flex', justifyContent: 'center'}}>
                    
                    <Button  variant="outlined" onClick={handleClickOpen}>
                        Códigos Abreviados
                    </Button>

                </Box>

                <ScutInfo
                    productos={productos}
                    //open={openScutDialog}
                    setOpen={setOpenScutDialog}
                />

            </Stack>
        </Box>
    )
    //===============================================================================================================
}

export default PosAdd